import {Injectable, PLATFORM_ID, Inject} from '@angular/core';
import {isPlatformBrowser, DOCUMENT} from '@angular/common';
import {TranslateService} from "@ngx-translate/core";
import {ApiService} from "./api.service";
import {environment} from "../../environments/environment";
import {Subject} from "rxjs";
import {debounceTime} from "rxjs/operators";

@Injectable({providedIn: 'root'})
export class SettingService {

	public lang = 'tc';
	public lang_list = [
		{key: 'tc', label: '繁體中文', short_label: '繁'},
		{key: 'sc', label: '简体中文', short_label: '简'},
		{key: 'en', label: 'English', short_label: 'EN'},
	];

	public loginDomain = environment.loginDomain;
	public online_shop_tag_id = environment.online_shop_tag_id;
	public online_shop_school_id = environment.online_shop_school_id;
	public ro_path = environment.ro_path;
	website_title = null;

	private isBrowser: boolean;

	private custom_content_subject = new Subject();
	custom_content_keys = [];
	custom_content_resolve_list = [];
	custom_content_cache = {};
	custom_content_cache_time = {};

	constructor(
		@Inject(PLATFORM_ID) platformId: Object,
		@Inject(DOCUMENT) private document: Document,
		public trans: TranslateService,
		public api: ApiService,
	) {
		this.isBrowser = isPlatformBrowser(platformId);
		this.custom_content_subject.pipe(debounceTime(100)).subscribe(async () => {
			let keys = [...new Set(this.custom_content_keys)];
			let resolve_list = [...this.custom_content_resolve_list];
			this.custom_content_keys = [];
			this.custom_content_resolve_list = [];
			let map = await this._get_custom_content(keys);
			this.custom_content_cache = {
				...this.custom_content_cache,
				...map,
			}
			this.custom_content_cache_time = {
				...this.custom_content_cache_time,
				...keys.reduce((acc, key) => {
					acc[key] = (new Date().getTime()) + 5 * 60 * 1000; // 快取 5 分鐘
					return acc;
				}, {}),
			};
			resolve_list.forEach(resolve => {
				resolve(map);
			});
		})
	}

	get is_browser() {
		return this.isBrowser;
	}

	set_lang(lang) {
		this.lang = lang;
		this.trans.use(lang);
		this.api.lang = lang;
	}

	get_lang() {
		return this.lang;
	}

	get next_lang() {
		let current_index = this.lang_list.findIndex(lang => lang.key === this.lang);
		let next_index = current_index + 1;
		if (next_index >= this.lang_list.length) {
			next_index = 0;
		}
		return this.lang_list[next_index].key;
	}

	get is_lang_en() {
		return this.lang === 'en';
	}

	set_title(title = null, website_title = null) {
		// console.log(this.trans.currentLang);
		title = title ? title + ' - ' : '';
		this.trans.get('common.shop_title').subscribe(translated_str => {
			if (!website_title) {
				if (!this.website_title) {
					website_title = translated_str;
				} else {
					website_title = this.website_title
				}
			}
			title += website_title
			if (this.isBrowser) {
				this.document.title = title;
			}
		});
	}

	set_description(description = "") {
		if (!this.isBrowser) return;
		if(description === null) {
			description = "";
		}
		const meta = this.document.querySelector('meta[name="description"]');
		if (meta) {
			meta.setAttribute("content", description);
		}
	}


	get_custom_content(keys: string[]) {
		return new Promise(async (resolve, reject) => {
			// 如果快取裡全部都有，就直接回傳
			let now = new Date().getTime();
			let has_all_in_cache = keys.every(key => this.custom_content_cache[key] && this.custom_content_cache_time[key] && this.custom_content_cache_time[key] > now);
			if (has_all_in_cache) {
				let map = {};
				keys.forEach(key => {
					map[key] = this.custom_content_cache[key];
				});
				resolve(map);
				return;
			}

			// 想集合要獲取內容的 key，然後一次性從後端獲取，減少請求次數
			this.custom_content_resolve_list.push(resolve);
			this.custom_content_keys.push(...keys);
			this.custom_content_subject.next(null);
		});
	}

	private async _get_custom_content(keys: string[]) {
		let response = await this.api.post('ROOnlineShopCustomContentApi.get', {
			keys: [
				...keys,
			],
			school_id: this.online_shop_school_id,
		});

		if (response && response.status === 'success' && response.data) {
			return response.data;
		}

		return {};
	}
}